







import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({
  name: 'multiselect-clear',
})
export default class MultiselectClear extends Vue {
  @Prop({
    default: () => (value: any) => !!value,
  })
  public readonly checkEmpty!: (value: any) => boolean

  @Prop({
    default: undefined,
  })
  public readonly emptyValue!: any

  @Prop({
    required: true,
  })
  public readonly value!: any
}
